import { gql } from 'apollo-boost';

export const UPDATE_FOLDER_SHARE_ROLE = gql`
    mutation updateFolderShareRole($data: UpdateFolderShareRoleInput!) {
        updateFolderShareRole(data: $data)
    }
`;
